import React from 'react';
// import sections
import Hero from '../components/sections/Hero';
import ConceptsSection from '../components/sections/ConceptsSection';
import CoursesSection from '../components/sections/CoursesSection';
import MentorsSection from '../components/sections/MentorsSection';
import UsageSection from "../components/sections/UsageSection";
import CtaTitle from '../components/sections/CtaTitle';
import ScheduleSection from "../components/sections/ScheduleSection";
import CtaMain from "../components/sections/CtaMain";

const Home = () => {

    return (
        <>
            <Hero/>
            <ConceptsSection/>
            <CoursesSection invertMobile topDivider imageFill/>
            <MentorsSection topDivider/>
            <UsageSection topDivider/>
            <ScheduleSection topDivider/>
            <CtaTitle split/>
            <CtaMain split/>
        </>
    );
}

export default Home;